import { useState } from 'react';
import { Search }  from '../../assets/icons'
import { useSearchParams } from 'react-router-dom';

export const SearchBar = ({styled, onSearch}) => {
  const [isFocused, setIsFocused] = useState(false);

  const [searchParams, setSearchParams] = useSearchParams();
  const query = searchParams.get('query'); // ←

  const [searchQuery, setSearchQuery] = useState(query);


  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value)
    setSearchParams({ query: e.target.value });
  }


  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      onSearch(searchQuery);
    }
  };

  return (
    <div className="w-full">
      <div className={`
          flex items-center bg-[#F0F1F5] rounded-full shadow-lg
          transition-all duration-300 ease-in-out
          ${styled && isFocused ? 'shadow-xl scale-105 ring-2 ring-orange-400 shadow-[0_0_12px_4px_rgba(255,140,0,0.4)]' : 'shadow-md hover:shadow-lg'}
          border border-gray-200
        `}>
        <div className="pl-3 sm:pl-4 pr-1 sm:pr-2 scale-75 sm:scale-100">
          <Search className={'w-5 h-5 text-gray-500'} />
        </div>
        <input
          type="text"
          value={searchQuery}
          onChange={handleSearchChange}
          onFocus={() => setIsFocused(true)}
          onBlur={() => setIsFocused(false)}
          onKeyPress={handleKeyPress}
          placeholder="Caută..."
          className="
              h-[40px] sm:h-[48px]
              flex-1 py-3 sm:py-4 px-1 sm:px-2 text-gray-700 bg-transparent
              outline-none text-sm sm:text-base placeholder-gray-400
              focus:placeholder-gray-300 transition-colors duration-200
            "
        />

        <button
          onClick={()=>{
           onSearch(searchQuery);
          }}
          className="
              mr-2 px-3 sm:px-6 py-1.5 sm:py-2.5 bg-blue-500 text-white rounded-full
              font-medium text-xs sm:text-sm transition-all duration-200
              hover:bg-blue-600 hover:shadow-md
              active:transform active:scale-95
              focus:outline-none focus:ring-2 focus:ring-blue-300
            "
        >
          Căutare
        </button>
      </div>
    </div>
  );
}